// extracted by mini-css-extract-plugin
export var modal = "_dq-0";